var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 17.13C11.59 17.82 10.42 17.82 9.66003 17.12L9.55003 17.02C4.30003 12.27 0.870031 9.16004 1.00003 5.28004C1.06003 3.58004 1.93003 1.95004 3.34003 0.990044C5.98003 -0.809956 9.24003 0.0300438 11 2.09004C12.76 0.0300438 16.02 -0.819956 18.66 0.990044C20.07 1.95004 20.94 3.58004 21 5.28004C21.14 9.16004 17.7 12.27 12.45 17.04L12.35 17.13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.3a87bb1aeb7d0f49229c9ee2d4945383.svg";
export { ForwardRef as ReactComponent };